import { apiCaller } from "../../services/AxiosInstance";
import { GET_VENUE } from "./VenueTypes";

export async function deleteAction(url, backUrl, history) {
  const response = await apiCaller({ method: "delete", url })
    .then((response) => {
      //   dispatch(confirmedDeletePostAction(postId));
      return response;
      // history.push(backUrl);
    })
    .catch((error) => {
      console.log("anvuoinsevsev", error);
      return error;
    });
  return response;
}

export async function create(url, backUrl, data, history) {
  return await apiCaller({ method: "post", data, url })
    .then((response) => {
      // const singlePost = {
      //     ...postData,
      //     id: response.data.name,
      // };
      //   dispatch(getAudiences());
      // dispatch(confirmedCreatePostAction(singlePost));
      // history.push(backUrl);
      // console.log("svnsuievbsev", response);
      return response;
    })
    .catch((error) => {
      console.log("anvuoinsevsev", error);
      throw error;
    });
};

export function get(url, params, confirmedGetActionType) {
  return (dispatch, getState) => {
    dispatch(loadingModel(true, confirmedGetActionType));
    apiCaller({ url, params })
      .then((response) => {
        // let posts = formatPosts(response.data);
        dispatch(loadingModel(false, confirmedGetActionType));
        dispatch(
          confirmedGetAction(confirmedGetActionType, response?.data?.data)
        );
      })
      .catch((error) => {
        dispatch(loadingModel(false, confirmedGetActionType));
        console.log(error);
      });
  };
}

export function confirmedGetAction(confirmedGetActionType, data) {
  return {
    type: confirmedGetActionType,
    payload: data,
  };
}

export function loadingModel(loading, action_model) {
  return {
    type: "LOADING",
    payload: {
      loading,
      action_model,
    },
  };
}

export async function updateAction(url, backUrl, data, history) {
  return await apiCaller({ method: "put", data, url })
    .then((response) => {
      //   dispatch(confirmedUpdatePostAction(post));
      // history.push(backUrl);
      return response;
    })
    .catch((error) => {
      console.log("anvuoinsevsev", error);
      throw error;
    });
}
